import React, { useState } from "react";
import useHttp from "../../hooks/use-http";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import "./NieuweCheckAS.css";
import FormAS from "./FormAS";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NieuweCheckAS = () => {
  const navigate = useNavigate();
  const { user } = useAuth0();
  const [timeoutLoading, setTimeoutLoading] = useState(false);

    const [inputData, setInputData] = useState({
      name: user?.name || "",
      email: user?.email || "",
      licensePlate: "",
      purchaseType: "PARTICULIER",
      language: "nl",
      agreedGtc: false,
      agreedDisclaimer: false,
    });


    const {
      sendRequest: startRunRequest,
      isLoading: startRunLoading,
      error: startRunError,
    } = useHttp();
  
    function startRun() {
      const formData = new FormData();
  
      let runConfig = {
        name: inputData.name,
        email: inputData.email,
        license_plate: inputData.licensePlate,
        purchase_type: inputData.purchaseType,
        language: inputData.language,
        agreed_gtc: inputData.agreedGtc,
        agreed_disclaimer: inputData.agreedDisclaimer,
      };
      
      formData.append("run_config", JSON.stringify(runConfig));
  
      function applyData(res) {
        setTimeout(() => navigate("/"), 2000);
        setTimeoutLoading(true);
      }
  
      startRunRequest(
        {
          url: `${REACT_APP_BACKEND_URL}/run/start_gym_check`,
          method: "POST",
          body: formData,
          isFileUpload: true,
        },
        applyData
      );
    }

  return (
    <div className="nc-container">
      <FormAS
        startRun={startRun}
        runLoading={startRunLoading || timeoutLoading}
        runError={startRunError}
        inputData={inputData}
        setInputData={setInputData}
      />
    </div>
  );
};

export default NieuweCheckAS;
